import { render, staticRenderFns } from "./detailNewOrder.vue?vue&type=template&id=135b13c5&scoped=true"
import script from "./detailNewOrder.vue?vue&type=script&lang=js"
export * from "./detailNewOrder.vue?vue&type=script&lang=js"
import style0 from "./detailNewOrder.vue?vue&type=style&index=0&id=135b13c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135b13c5",
  null
  
)

export default component.exports